import { render, staticRenderFns } from "./HelpClients.vue?vue&type=template&id=328c59ac&scoped=true"
import script from "./HelpClients.vue?vue&type=script&lang=js"
export * from "./HelpClients.vue?vue&type=script&lang=js"
import style0 from "./HelpClients.vue?vue&type=style&index=0&id=328c59ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c59ac",
  null
  
)

export default component.exports